import { RequestsStates } from "../../data/enums/requestsStates";
import { OperationRequestData } from "../../data/operationRequestData";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { AccountInDefaultModel } from "../../models/settings/accountInDefaultModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import BaseOperationService from "../operations/BaseOperationService";
import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import i18n from "@/i18n";

/**Сервис установки счета по умолчанию */
@injectable()
export default class AccountInDefaultService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  public PersonStore!: PersonStore;

  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    configStore: ConfigStore,
    personStore: PersonStore
  ): Promise<AccountInDefaultModel> {
    this.PersonStore = personStore;
    const operationData = new AccountInDefaultModel(personStore.personInfo);
    operationData.RespondentCode =
      configStore.apiData.OperationCodeOfSetDefaultInAccount;
    return operationData;
  }

  public async nextStep(model: AccountInDefaultModel): Promise<AccountInDefaultModel> {
     
    return (await super.execute(model)) as AccountInDefaultModel;
  }
  /**
   * Действия после проведения операции
   */
  public async afterExecute(model: AccountInDefaultModel): Promise<void> {
    this.PersonStore.personInfo.Data.DefaultInAccount = model.def_contract;
    this.alertService.success(i18n.t(`main.settings.messages.accountInDefaultExecuted`).toString());
  }

  /**Вычисляем статус операции после выполнения */
  public async analyzeState(
    model: AccountInDefaultModel,
    ord: OperationRequestData
  ): Promise<AccountInDefaultModel> {
    model._actionState =
      ord.requestState == RequestsStates.Executed ||
      ord.requestState == RequestsStates.None
        ? ActionStateEnum.Success
        : [3, 6, 7].indexOf(ord.requestState as number)
        ? ActionStateEnum.Error
        : ActionStateEnum.Executing;
    model.ActionStateText = ord.requestStateDescription;
    return model;
  }
}
